import { render, staticRenderFns } from "./HeroImage.vue?vue&type=template&id=0454184c&"
import script from "./HeroImage.vue?vue&type=script&lang=js&"
export * from "./HeroImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports